import React from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { Icon } from 'js/components/common/Icon';
import { getClassNames } from 'js/utils/classNames.util';

import Bullets from './Bullets';
import * as hooks from './hooks';
import { useDynamicReducerSelector } from './store';

import style from './index.scss';

export const Controls = (props) => {
    const {
        sliderMove,
        sliderMoveLeft,
        sliderMoveRight
    } = hooks.useSliderNavigation(props);
    const {
        options: {
            arrows,
            bullets,
            buttons
        },
        classNames: {
            leftArrow = '',
            rightArrow = '',
            disabledArrow = '',
            ...classNames
        } = {},
        activeSlide,
        slidesCount,
        infinite,
        isBulletsClickable,
        showDisabledArrows = false
    } = props;
    const isMirrorMode = useDynamicReducerSelector(prop('isMirrorMode'));
    const arrowsStyle = hooks.useArrowStyles(arrows);
    const bulletsClassNames = hooks.useBulletsClassNames(classNames);
    const onBulletClick = hooks.useBulletClickHandler({ activeSlide, sliderMove });
    const translate = useTranslations('playtech.mobile.system.slider.');
    const isLeftArrowActive = infinite
        || (!isMirrorMode && activeSlide !== 0 || isMirrorMode && activeSlide !== slidesCount - 1);
    const isRightArrowActive = infinite
        || (!isMirrorMode && activeSlide !== slidesCount - 1 || isMirrorMode && activeSlide !== 0);
    const leftArrowClassNames = getClassNames([
        style.leftArrow,
        classNames.arrows || '',
        leftArrow,
        showDisabledArrows && !isLeftArrowActive ? disabledArrow || style.disabledArrow : ''
    ]);
    const rightArrowClassNames = getClassNames([
        style.rightArrow,
        classNames.arrows || '',
        rightArrow,
        showDisabledArrows && !isRightArrowActive ? disabledArrow || style.disabledArrow : ''
    ]);

    return (
        <>
            {(bullets.enabled || buttons.enabled) && (
                <Bullets
                    count={slidesCount}
                    onClick={onBulletClick}
                    activeSlide={activeSlide}
                    position={bullets.position}
                    showNumbers={buttons.enabled}
                    classNames={bulletsClassNames}
                    isBulletsClickable={isBulletsClickable}
                />
            )}
            {arrows.enabled && (showDisabledArrows || isLeftArrowActive) && (
                <Icon
                    role="button"
                    style={arrowsStyle}
                    className={leftArrowClassNames}
                    type={`${leftArrow ? '' : 'leftArrow'}`}
                    {...isLeftArrowActive && { onClick: sliderMoveLeft }}
                    aria-label={translate('aria-label.leftArrowButton')}
                />
            )}
            {arrows.enabled && (showDisabledArrows || isRightArrowActive) && (
                <Icon
                    role="button"
                    style={arrowsStyle}
                    className={rightArrowClassNames}
                    type={`${rightArrow ? '' : 'rightArrow'}`}
                    {...isRightArrowActive && { onClick: sliderMoveRight }}
                    aria-label={translate('aria-label.rightArrowButton')}
                />
            )}
        </>
    );
};

export default Controls;
